import {
  Brain,
  Check,
  CloudArrowUp,
  CornersOut,
  Download,
  FilmStrip,
  Gear,
  Globe,
  Lightbulb,
  Lightning,
  Play,
  PlayCircle,
  Plug,
  Scissors,
} from '@phosphor-icons/react';
import { Flex } from 'antd';

const VideoTool = () => {
  return (
    <div className="carousel-slide carousel-one-slide">
      <div className="carousel-one-decorations">
        <div className="carousel-one-hexagon"></div>
        <div className="carousel-one-hexagon"></div>
        <div className="carousel-one-hexagon"></div>
        <div className="carousel-one-circuit"></div>
        <div className="carousel-one-particles">
          <div className="carousel-one-particle carousel-one-particle-1"></div>
          <div className="carousel-one-particle carousel-one-particle-2"></div>
          <div className="carousel-one-particle carousel-one-particle-3"></div>
          <div className="carousel-one-particle carousel-one-particle-4"></div>
          <div className="carousel-one-particle carousel-one-particle-5"></div>
          <div className="carousel-one-particle carousel-one-particle-6"></div>
          <div className="carousel-one-particle carousel-one-particle-7"></div>
          <div className="carousel-one-particle carousel-one-particle-8"></div>
          <div className="carousel-one-particle carousel-one-particle-9"></div>
          <div className="carousel-one-particle carousel-one-particle-10"></div>
        </div>
        <div className="carousel-one-gradient-overlay"></div>
      </div>
      <Flex className="container carousel-content-wrapper" align="center">
        <div className="flex-1 carousel-content">
          <div className="carousel-one-badge">
            <div className="carousel-one-badge-pulse"></div>
            <span>AI驱动·全场景视频生产力</span>
          </div>
          <h1 className="carousel-title carousel-one-title">
            <span className="carousel-one-title-main">智能视频</span>
            <span className="carousel-one-title-highlight">创作中心</span>
          </h1>
          {/* <p className="carousel-one-description">
                一键将AI生成的视频内容导入剪映，快速完成剪辑与合成，支持本地草稿与云端MP4
              </p> */}
          <div className="carousel-one-features">
            <div className="carousel-one-feature">
              <div className="carousel-one-feature-icon">
                <Globe weight="bold" />
              </div>
              <div className="carousel-feature-content">
                <h4 className="carousel-feature-title">多平台支持</h4>
                <p className="carousel-feature-desc">支持扣子国内/海外平台</p>
              </div>
            </div>
            <div className="carousel-one-feature">
              <div className="carousel-one-feature-icon">
                <Brain weight="fill" />
              </div>
              <div className="carousel-feature-content">
                <h4 className="carousel-feature-title">智能创作</h4>
                <p className="carousel-feature-desc">图转视频/图生视频（AI生成动态内容）</p>
              </div>
            </div>
            <div className="carousel-one-feature">
              <div className="carousel-one-feature-icon">
                <Scissors weight="fill" />
              </div>
              <div className="carousel-feature-content">
                <h4 className="carousel-feature-title">专业编辑</h4>
                <p className="carousel-feature-desc">视频拼接·裁剪·字幕特效·多轨配音</p>
              </div>
            </div>
            <div className="carousel-one-feature">
              <div className="carousel-one-feature-icon">
                <FilmStrip weight="fill" />
              </div>
              <div className="carousel-feature-content">
                <h4 className="carousel-feature-title">应用场景</h4>
                <p className="carousel-feature-desc">短视频制作·营销广告·教育培训</p>
              </div>
            </div>
          </div>

          <div className="carousel-extension">
            <Lightbulb size={24} weight="fill" /> "可按需接入企业私有工作流"
          </div>
        </div>
        <div className="flex-1 relative carousel-right">
          <div className="carousel-one-visual">
            <div className="carousel-one-glow carousel-one-glow-1"></div>
            <div className="carousel-one-glow carousel-one-glow-2"></div>
            <div className="carousel-one-devices">
              <div className="carousel-one-connections">
                <div className="carousel-one-connection carousel-one-connection-1"></div>
                <div className="carousel-one-connection carousel-one-connection-2"></div>
              </div>
            </div>
          </div>
          <div className="carousel-one-video-preview">
            <div className="carousel-video-overlay">
              <div className="carousel-play-button">
                <PlayCircle size={40} weight="fill" />
              </div>
            </div>
            <div className="carousel-one-floating-elements">
              <div className="carousel-one-floating-window carousel-one-floating-window-1">
                <div className="carousel-one-window-icon">
                  <Plug weight="fill" />
                </div>
                <div className="carousel-one-window-text">扣子插件定制</div>
              </div>
              <div className="carousel-one-floating-window carousel-one-floating-window-2">
                <div className="carousel-one-window-icon">
                  <Plug weight="fill" />
                </div>
                <div className="carousel-one-window-text">MCP插件定制</div>
              </div>
            </div>
          </div>
        </div>
      </Flex>
    </div>
  );
};

export default VideoTool;
